import React from 'react'
import { Route, Switch } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import SupplierQueue from 'src/features/supplier/pages/SupplierQueue/SupplierQueue'
import SupplierReceivement from 'src/features/supplier/pages/SupplierReceivement/SupplierReceivement'
import { createGlobalStyle } from 'styled-components'
import Header from '../components/Common/header'
import Sidebar from '../components/Common/sidebar'
import Secured from '../components/security/Secured'
import { MENUITEMS } from '../data/menu'
import FeatureRoutes from '../features/index'
import NewReceivementBatchNotBarcode from '../features/receivement/pages/BatchesWithoutBarcode'
import NewReceivement from '../features/receivement/pages/NewReceivement'
import NewReceivementDetails from '../features/receivement/pages/NewReceivementDetails'
import NewReceivementStart from '../features/receivement/pages/NewReceivementStart'
import ReceivementDivergence from '../features/receivement/pages/ReceivementDivergence'
import ReceivementFinish from '../features/receivement/pages/ReceivementFinish'
import ReceivementList from '../features/receivement/pages/ReceivementList/ReceivementList'
import ReceivementOverview from '../features/receivement/pages/ReceivementOverview'
import ReceivementPurchase from '../features/receivement/pages/ReceivementPurchase'
import ReceivementOverviewList from '../features/receivement-overview-list/pages/ReceivementOverviewList'
import Adjustments from '../pages/Adjustments'
import DockAssignPage from '../pages/DockAssignPage'
import Fraction from '../features/fraction/pages/Fraction'
import Loss from '../features/loss/pages/Loss/Loss'
import Movimentation from '../pages/Movimentation/Movimentation'
import ReceivementFresh from '../pages/ReceivementFresh/ReceivementFresh'
import SupervisorLoginPage from '../pages/SupervisorLoginPage'
import SurplusMapping from '../pages/SurplusMapping/SurplusMapping'
import Withdraw from '../pages/Withdraw/Withdraw'
import { PendingReceivementsTable } from '../features/pending-receivements/pages/PendingReceivementsTable'
import { ManagerBadge } from 'src/features/pending-receivements/pages/ManagerBadge'
import { PendingReceivement } from 'src/features/pending-receivements/pages/PendingReceivement'
import { ReplacementMainPage } from 'src/features/stock-movements/pages/ReplacementMainPage/ReplacementMainPage'
import { PkMovementPage } from 'src/features/stock-movements/pages/PkMovementPage'
import { ReplacementPage } from 'src/features/stock-movements/pages/ReplacementPage/ReplacementPage'
import { BatchesMovement } from 'src/features/stock-movements/pages/BatchesMovement'
import EmailSettings from 'src/features/email-settings/pages/EmailSettings/EmailSettings'



const GlobalStyle = createGlobalStyle`
  .page-body {
    padding-top: 50px !important;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`

function Routes({ user, onLock, onLogout, onChangeFulfillmentCenter }) {

  return (
    <>
      <div className='page-wrapper'>
        <div className='page-body-wrapper without-header'>
          <Header useMiniSidebar={false} />
          <Sidebar
            menuItems={MENUITEMS}
            user={user}
            lock={onLock}
            logout={onLogout}
            onChangeFulfillmentCenter={onChangeFulfillmentCenter}
          />
          <div className='page-body' style={{ marginTop: '50px' }}>
            <Switch>
              <Route path='/supervisor/login' component={SupervisorLoginPage} />
              <Route path='/dock-assign' component={DockAssignPage} />
              <Route 
                path='/movement/batches' 
                exact 
                component={() => (
                  <Secured claim='movement:movement'>
                    <BatchesMovement />
                  </Secured>
                )}
              />
              <Route 
                path='/movements/replacement-main' 
                exact 
                component={() => (
                  <Secured claim='movement:movement'>
                    <ReplacementMainPage />
                  </Secured>
                )}
              />
              <Route 
                path='/movements/replacement' 
                exact 
                component={() => (
                  <Secured claim='movement:movement'>
                    <ReplacementPage />
                  </Secured>
                )}
              />
              <Route 
                path='/movements/pk-movement' 
                exact 
                component={() => (
                  <Secured claim='movement:movement'>
                    <PkMovementPage />
                  </Secured>
                )}
              />
              <Route
                path='/pending-receivement/:receivementId/conference'
                component={() => (
                  <Secured claim='home:list_pending_receivements'>
                    <PendingReceivement />
                  </Secured>
                )}
              />,
              <Route 
                path='/pending-receivement/:receivementId/badge'  
                component={ManagerBadge}
              />,
              <Route
                path='/pending-receivements'
                component={() => (
                  <Secured claim='home:list_pending_receivements'>
                    <PendingReceivementsTable />
                  </Secured>
                )}
              />,
              <Route
                path='/email-settings'
                component={() => (
                  <Secured claim='receivement:configuration'>
                    <EmailSettings />
                  </Secured>
                )}
              />,
              <Route
                path='/receivement/list'
                component={() => (
                  <Secured claim='home:receivement'>
                    <ReceivementOverviewList />
                  </Secured>
                )}
              />
              <Route
                path='/receivement/:receivementId/details'
                component={() => (
                  <Secured claim='home:receivement'>
                    <NewReceivementDetails />
                  </Secured>
                )}
              />
              <Route
                path='/receivement/:receivementId/purchase'
                component={() => (
                  <Secured claim='home:receivement'>
                    <ReceivementPurchase />
                  </Secured>
                )}
              />
              <Route
                path='/receivement/:receivementId/divergence'
                component={() => (
                  <Secured claim='home:receivement'>
                    <ReceivementDivergence />
                  </Secured>
                )}
              />
              <Route
                path='/receivement/:receivementId/batches-without-barcode'
                component={() => (
                  <Secured claim='home:receivement'>
                    <NewReceivementBatchNotBarcode />
                  </Secured>
                )}
              />
              <Route
                path='/receivement/:receivementId/finish'
                component={() => (
                  <Secured claim='home:receivement'>
                    <ReceivementFinish />
                  </Secured>
                )}
              />
              <Route
                path='/receivement/:receivementId/overview'
                component={() => (
                  <Secured claim='home:receivement'>
                    <ReceivementOverview />
                  </Secured>
                )}
              />
              <Route
                path='/receivement/:receivementId'
                component={() => (
                  <Secured claim='home:receivement'>
                    <NewReceivement />
                  </Secured>
                )}
              />
              <Route
                path='/receivement'
                component={() => (
                  <Secured claim='home:receivement'>
                    <NewReceivementStart />
                  </Secured>
                )}
              />
              <Route
                path='/fresh/receivement'
                component={() => (
                  <Secured claim='home:receivement_fresh'>
                    <ReceivementFresh />
                  </Secured>
                )}
              />
              <Route
                path='/fresh/fraction'
                component={() => (
                  <Secured claim='home:fractioning'>
                    <Fraction />
                  </Secured>
                )}
              />
              <Route
                path='/stock/withdraws'
                component={() => (
                  <Secured claim='home:withdraws'>
                    <Withdraw />
                  </Secured>
                )}
              />
              <Route
                path='/adjustments/stock-adjustment'
                component={() => (
                  <Secured claim='home:adjust'>
                    <Adjustments />
                  </Secured>
                )}
              />
              <Route
                path='/adjustments/loss'
                component={() => (
                  <Secured claim='home:loss'>
                    <Loss />
                  </Secured>
                )}
              />
              <Route
                path='/stock/movimentations'
                component={() => (
                  <Secured claim='home:list_movement'>
                    <Movimentation />
                  </Secured>
                )}
              />
              <Route
                path='/list/receivement'
                component={() => (
                  <Secured claim='home:list_receivement'>
                    <ReceivementList />
                  </Secured>
                )}
              />
              <Route
                path='/suppliers/queue'
                component={() => (
                  <Secured claim='home:list_receivement'>
                    <SupplierQueue />
                  </Secured>
                )}
              />
              <Route
                path='/suppliers/receivement'
                component={() => (
                  <Secured claim='home:list_receivement'>
                    <SupplierReceivement />
                  </Secured>
                )}
              />
              <Route
                path='/surplus-mapping'
                component={() => (
                  <Secured claim='mapping:surplus_mapping'>
                    <SurplusMapping />
                  </Secured>
                )}
              />
              {FeatureRoutes}
            </Switch>
          </div>
        </div>
      </div>
      <GlobalStyle />
    </>
  )
}

export default Routes
